<template>
  <div class="tabs-v3">
    <ul class="tab-container">
      <li
        v-for="(item, index) in list"
        :key="index"
        @click="changeTab(item)"
        :class="[item.name == value ? 'is-active' : '', 'tab-item']"
      >
      <div class="tabs-item-div" style="padding: 0 8px">
         <span>
          {{item.name}}
        </span>
      </div>
     </li>
    </ul>
    <div class="tabs-right">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'common-tabs-v3',
  data() {
    return {
    }
  },
  model: {
    event: 'change'
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Number],
      default: ''
    },
  },
  computed: {
  },
  watch: {
  },
  methods: {
    changeTab(val) {
      if (val.name == this.activTabsId) return
      this.$emit('change', val.name)
      this.$emit('changeBar', val)
    }
  }
}
</script>
<style lang="scss" scoped>
.tabs-v3{
  position: relative;
  border-top: 1px solid #f0f2f5;
  .tabs-right{
    position: absolute;
    z-index: 1;
    top: 8px;
    right: 24px;
  }
  .tab-container{
    height: 50px;
    padding: 14px 20px 0;
    display: flex;
    background-color: #ffffff;
    border-bottom: 1px solid #dadce1;
    .tab-item {
      margin-right: 4px;
      position: relative;
      // border-top: 1px solid transparent;
      // border-left: 1px solid transparent;
      // border-right: 1px solid transparent;
      // border-top-left-radius: 5px;
      // border-top-right-radius: 5px;
      padding: 0 6px;
      color: #4c556c;
      background-color: #ffffff;
      cursor: pointer;
      text-align: center;
      .tabs-item-div{
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      span{
        font-size: 14px;
        font-weight: 500;
        color: #4c556c;
      }
      &.is-active {
        position: relative;
        border-color: #dadce1;
        color: #4066d4;
        &::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          height: 2px;
          background-color: #fff;
          z-index: 1;
        }
        .tabs-item-div{
          border-top: 1px solid #dadce1;
          background: #fff !important;
        }
        span{
          font-weight: bold;
          color: #4066d4;
          &::before{
            content: '';
            position: absolute;
            left: -4px;
            top: 0;
            width: 10px;
            bottom: 0px;
            background: url('~@/assets/img/com-2/invalid-left.svg') no-repeat  !important;
          }
          &::after{
            content: '';
            position: absolute;
            right: -4px;
            top: 0;
            width: 10px;
            bottom: 0px;
            background: url('~@/assets/img/com-2/invalid-right.svg') no-repeat !important;
          }
        }
      }
      &:hover{
        .tabs-item-div{
          background: #F5F6F9;
        }
        span{
          &::before{
            content: '';
            position: absolute;
            left: -4px;
            top: 0;
            width: 10px;
            bottom: 0px;
            background: url('~@/assets/img/com-2/hover-left.svg') no-repeat;
          }
          &::after{
            content: '';
            position: absolute;
            right: -4px;
            top: 0;
            width: 10px;
            bottom: 0px;
            background: url('~@/assets/img/com-2/hover-right.svg') no-repeat;
          }
        }
      }
    }
  }
}
</style>
